import { FiSearch } from 'react-icons/fi';
import { ResultsCount, SearchField, ToolbarRow } from './catalogStyles';

export const CatalogToolbar = ({ searchValue, onSearchChange, totalItems, showResults }) => (
    <ToolbarRow>
        <SearchField>
            <FiSearch />
            <input
                value={searchValue}
                onChange={(event) => onSearchChange(event.target.value)}
                placeholder="Buscar por nome ou código do produto"
                aria-label="Buscar por nome ou código do produto"
            />
        </SearchField>
        {showResults && (
            <ResultsCount>
                {totalItems} {totalItems === 1 ? 'resultado encontrado' : 'resultados encontrados'}
            </ResultsCount>
        )}
    </ToolbarRow>
);
